var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoRdv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 50,
    viewBox: "0 0 165 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-203 -23)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Rendez-vous_En_Mairie",
    "data-name": "Rendez-vous En Mairie",
    transform: "translate(353 43)",
    fill: "#c74c51",
    fontSize: 21,
    fontFamily: "Raleway-Light, Raleway",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -149.331,
    y: 0
  }, "RENDEZ-VOUS"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Raleway-ExtraBold, Raleway",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -104.79,
    y: 25
  }, "EN MAIRIE"))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M2196.667,63.144s16.1,2.187,25.333-9.477",
    transform: "translate(-1985 7.583)",
    fill: "none",
    stroke: "#c74c51",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4242",
    "data-name": "Ellipse 4242",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(209 56)",
    fill: "#c74c51"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4243",
    "data-name": "Ellipse 4243",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(226 51)",
    fill: "#c74c51"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRdv);
export default __webpack_public_path__ + "static/media/logo-rdv.0e26ab19dc68083daea9857c01efa121.svg";
export { ForwardRef as ReactComponent };